import { IconPaperclip, IconMail } from '@/components/icons/Icons'
import { inicialDe, colorAvatar, fechaCorta } from '@/lib/correo-utils'

/*
  Una fila de la bandeja. La jerarquía es la de Gmail —quién, sobre qué, y de
  qué iba— porque es lo que la gente ya sabe leer de un vistazo.

  El prop shape es **neutral**: el componente no sabe qué es un `ProyectoCorreo`
  ni un `BuzonHilo`. Cada caller calcula `quien` con `etiquetaHilo()` y pasa el
  resultado, porque de dónde sale "nuestro" dominio cambia según la pantalla
  (en una ficha sale de quién archivó el hilo; en el buzón, del remitente).
*/
interface Props {
  /** Con quién es el hilo, ya resuelto por el caller. */
  quien: string
  asunto: string | null
  /** Dirección que decide el color y la inicial del avatar. */
  avatarDe?: string
  /** Primera línea del último mensaje. Opcional: la ficha no la muestra. */
  resumen?: string | null
  fecha: string | null
  adjuntos?: number
  /** Cantidad de mensajes del hilo. Solo se muestra si es más de uno. */
  mensajes?: number
  noLeidos?: number
  activo: boolean
  onClick: () => void
}

export default function CorreoListaItem({
  quien, asunto, avatarDe, resumen, fecha, adjuntos = 0, mensajes = 0, noLeidos = 0,
  activo, onClick,
}: Props) {
  const clave = avatarDe || quien

  return (
    <div
      className={`correo-item${activo ? ' is-activo' : ''}${noLeidos > 0 ? ' is-no-leido' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick() } }}
    >
      <div
        className="correo-item__avatar"
        style={{ background: colorAvatar(clave) }}
        aria-hidden
      >
        {inicialDe(clave)}
      </div>

      <div className="correo-item__cuerpo">
        <div className="correo-item__fila">
          <span className="correo-item__de">{quien}</span>
          <span className="correo-item__fecha">{fechaCorta(fecha)}</span>
        </div>
        <div className="correo-item__asunto">{asunto || '(sin asunto)'}</div>
        {resumen && <div className="correo-item__fragmento">{resumen}</div>}
        {(mensajes > 1 || adjuntos > 0) && (
          <div className="correo-item__meta">
            {mensajes > 1 && (
              <span className="correo-item__chip"><IconMail size={10} /> {mensajes}</span>
            )}
            {adjuntos > 0 && (
              <span className="correo-item__chip"><IconPaperclip size={10} /> {adjuntos}</span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
